module.exports = __webpack_public_path__ + "static/media/loader.5d71e4d7.gif";